import { Button } from '@hai/ui-react';
import { ButtonStateType, IButtonProps } from '@hai/ui-react/dist/types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { triggerEvent, watchEvent } from 'src/js/events';
import { useStores } from 'src/js/hook/use-stores';
import { decodersStore } from 'src/js/pages/streaming/decoder/decoder-store';
import { useWatchObject } from 'src/js/store/use-watch';
import { flattenArray } from 'src/js/util/flatten-array/flatten-array';

interface DecoderButtonsProps {
  submitApplyAllDecoders: () => Promise<any>;
  cancelChanges: VoidFunction;
}

export const DecoderButtons: React.FunctionComponent<DecoderButtonsProps> = ({
  submitApplyAllDecoders,
  cancelChanges,
}) => {
  const { sessionStore } = useStores();
  const { t } = useTranslation();
  const [hasDecodersChanged, setHasDecodersChanged] = useState(false);
  const [buttonState, setButtonState] = useState<ButtonStateType>(undefined);

  const onSubmit = () => {
    setButtonState('pending');
    // This is the begining and end of the global APPLY button
    // tag(ORDER-SAVE)
    submitApplyAllDecoders().then((allResponses) => {
      const success = flattenArray(allResponses)?.filter((r: any) => r?.ok === true);
      const failed = flattenArray(allResponses)?.filter((r: any) => r?.ok === false);
      /*console.log(
        'submitApplyAllDecoders success, failures',
        success?.length,
        failed?.length,
        flattenArray(allResponses),
      );*/
      if (failed?.length === 0 && success?.length > 0) {
        // console.log('all succcess', allResponses);
        // we prefer no notifications createAndDispatchNotification(t('decoder.notifications.allDecoderSuccess'), NotificationVariant.SUCCESS, t);
        decodersStore.reset();
      } else if (success?.length > 0) {
        // console.log('succcess', success);
      } else {
        // console.warn('there were some errors', failed, allResponses);
      }
      triggerEvent('preset-update');
      triggerEvent('decoders-apply-completed');
    });
  };

  watchEvent('decoders-apply-completed', () => {
    setButtonState(undefined);
  });

  useWatchObject(decodersStore, (_updated) => {
    if (decodersStore.hasItemsChanged()) {
      setHasDecodersChanged(true);
    } else {
      setHasDecodersChanged(false);
    }
  });

  return (
    <>
      {hasDecodersChanged && (
        <div className="hai-mb-4 hai-mt-4" id="decoders-top-buttons">
          <div>
            {sessionStore.isUser() ? null : (
              <div className="d-flex justify-content-end">
                <Button
                  {...({ id: 'cancel-decoders' } as IButtonProps)}
                  className="hai-mr-4"
                  onClick={cancelChanges}
                  disabled={buttonState === 'pending'}
                >
                  {t('general.cancel')}
                </Button>
                <Button
                  // id="apply-decoders"
                  {...{ id: 'apply-decoders' }}
                  variant="primary"
                  onClick={onSubmit}
                  state={buttonState}
                >
                  {t('general.applyChanges')}
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
